export default __webpack_public_path__ + "ce3fff31c0f262aca227664f6f0d2fa2.ttf";